export const getTableStorageKey = (prefix: string, tableName?: string) =>
    tableName ? `${prefix}${tableName}` : undefined;

export const isRecordOf =
    <T>(isItem: (item: unknown) => item is T) =>
    (value: unknown): value is Record<string, T> =>
        typeof value === 'object' && value !== null && !Array.isArray(value) && Object.values(value).every(isItem);

export const readTableStorage = <T>(
    prefix: string,
    tableName: string | undefined,
    isValid: (value: unknown) => value is T,
    fallback: T,
): T => {
    const key = getTableStorageKey(prefix, tableName);
    if (!key) return fallback;

    try {
        const value = localStorage.getItem(key);
        const parsed: unknown = value ? JSON.parse(value) : undefined;
        return isValid(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};
